import React, { Component } from 'react'
import _ from 'lodash'
import { Link, withRouter } from 'react-router-dom'
import moment from 'moment'
import { observer } from 'mobx-react'
import { Row, Col, Skeleton, Empty } from 'antd'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import ConstituentAvatar from '../../components/Custom/ConstituentAvatar'
import ActionDetails from './actionDetails'
import SettlementForm from './settlementForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isEditSettlementShown: false,
			selectedComplain: null
		}
	}

	render() {
		const { isEditSettlementShown, selectedComplain } = this.state
		const { match, history } = this.props
		const complain_uid = _.has(match.params, 'complain_uid') ? match.params.complain_uid : null
		if (!complain_uid) return history.push('/complains')

		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Barangay Issues</a></li>
									<li className="breadcrumb-item"><Link to='/complains'>Complaints</Link></li>
									<li className="breadcrumb-item active">Complaint Details</li>
								</ol>
							</div>
							<h4 className="page-title">Complaint Details</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Query
									query={COMPLAIN_BY_UID}
									variables={{ complain_uid }}
									fetchPolicy='network-only'
								>
									{({ loading, error, data }) => {
										if (loading) return <Skeleton active/>
										if (error) return <Empty />

										let complain = _.has(data,'barangayComplainByUid') ? data.barangayComplainByUid : {}
										if (!_.has(complain, 'status')) {
											return window.location.href = '/complains'
										}

										let badgeType = 'badge-primary'
										if (_.isEqual(complain.status, 'Pending')) {
											badgeType = 'badge-info'
										} else if (_.isEqual(complain.status, 'On-Going')) {
											badgeType = 'badge-warning'
										} else if (_.isEqual(complain.status, 'File to Action')) {
											badgeType = 'badge-danger'
										} else if (_.isEqual(complain.status, 'Settled')) {
											badgeType = 'badge-success'
										} else if (_.isEqual(complain.status, 'Referral')) {
											badgeType = 'badge-purple'
										}
										return (
											<React.Fragment>
												<Row gutter={24}>
													<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Case No.</h4></Col>
													<Col md={16} sm={12}><h4>{complain.case_no}</h4></Col>
												</Row>
												<Row gutter={24} style={{ marginTop: 10 }}>
													<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Status</h4></Col>
													<Col md={16} sm={12}><h4><span className={`badge ${badgeType}`}>{complain.status}</span></h4></Col>
												</Row>
												<Row gutter={24} style={{ marginTop: 10 }}>
													<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Nature of Case</h4></Col>
													<Col md={16} sm={12}><h4>{complain.nature_of_case}</h4></Col>
												</Row>
												<Row gutter={24} style={{ marginTop: 10 }}>
													<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Date Filed</h4></Col>
													<Col md={16} sm={12}><h4>{moment(complain.date_filed).format('lll')}</h4></Col>
												</Row>
												<Row style={{ padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
													{
														complain.complainants.map((i, key) => (
															<React.Fragment key={key}>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Complainant {(key + 1)}</h4></Col>
																	<Col md={16} sm={12}>
																		{/* {
																			i.complainant_ref_uid &&
																		<ConstituentAvatar style={{ marginRight: 15 }} size={50}  constituent_uid={i.complainant_ref_uid}/>
																		} */}
																		<h4>{i.complainant_name}</h4>
																	</Col>
																</Row>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Complainant {(key + 1)} Address</h4></Col>
																	<Col md={16} sm={12}><h4>{i.complainant_address}</h4></Col>
																</Row>
															</React.Fragment>
														))
													}
												</Row>
												<Row style={{ marginTop: 10, padding: 10, border: '1px solid #ccc', borderRadius: 16 }}>
													{
														complain.respondents.map((i, key) => (
															<React.Fragment key={key}>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Respondent {(key + 1)}</h4></Col>
																	<Col md={16} sm={12}>
																		{/* {
																			i.respondent_ref_uid &&
																		<ConstituentAvatar style={{ marginRight: 15 }} size={50}  constituent_uid={i.respondent_ref_uid}/>
																		} */}
																		<h4>{i.respondent_name}</h4>
																	</Col>
																</Row>
																<Row gutter={24} style={{ marginTop: 10 }}>
																	<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Respondent {(key + 1)} Address</h4></Col>
																	<Col md={16} sm={12}><h4>{i.respondent_address}</h4></Col>
																</Row>
															</React.Fragment>
														))
													}
												</Row>
												{
													complain.specific_case &&
													<Row gutter={24} style={{ marginTop: 10 }}>
														<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Specific Case</h4></Col>
														<Col md={16} sm={12}><h4>{complain.specific_case}</h4></Col>
													</Row>
												}
												{
													complain.main_agreement &&
													<Row gutter={24} style={{ marginTop: 10 }}>
														<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Main point of agreement</h4></Col>
														<Col md={16} sm={12}><h4>{complain.main_agreement}</h4></Col>
													</Row>
												}
												{
													complain.end_remarks &&
													<Row gutter={24} style={{ marginTop: 10 }}>
														<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Agreement Remarks</h4></Col>
														<Col md={16} sm={12}><h4>{complain.end_remarks}</h4></Col>
													</Row>
												}
												{
													complain.date_settlement &&
													<Row gutter={24} style={{ marginTop: 10 }}>
														<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Date Settlement or Award</h4></Col>
														<Col md={16} sm={12}><h4>{moment(complain.date_settlement).format('ll')}</h4></Col>
													</Row>
												}
												{
													complain.date_execution_settlement &&
													<Row gutter={24} style={{ marginTop: 10 }}>
														<Col md={8} sm={24}><h4 style={{ color: 'gray' }}>Date of Execution of Settlement or Award</h4></Col>
														<Col md={16} sm={12}><h4>{moment(complain.date_execution_settlement).format('ll')}</h4></Col>
													</Row>
												}
												
												{
													!isEditSettlementShown &&
													<Row type='flex' justify='center' style={{ marginBottom: 20, marginTop: 20 }}>
														<button 
															type="button" 
															className="btn btn-primary btn-rounded waves-effect waves-light"
															onClick={(e) => {
																e.preventDefault()
																this.setState({ isEditSettlementShown: true, selectedComplain: complain })
															}}
														>
															<i className='mdi mdi-file-plus'/> Edit Settlement or Award Details
														</button>
													</Row>
												}
												{
													isEditSettlementShown &&
													<Row type='flex' justify='center' style={{ marginBottom: 20, marginTop: 20 }}>
														<button 
															type="button" 
															className="btn btn-danger btn-rounded waves-effect waves-light"
															onClick={(e) => {
																e.preventDefault()
																this.setState({ isEditSettlementShown: false, selectedComplain: null })
															}}
														>
															<i className='mdi mdi-file-plus'/> Close settlement or award form
														</button>
													</Row>
												}
												{
													isEditSettlementShown &&
													<Row style={{ padding: 10, border: '1px solid #ccc', borderRadius: 16, marginBottom: 10 }}>
														<SettlementForm 
															complain={selectedComplain}
															onClose={() => {
																this.setState({ isEditSettlementShown: false, selectedComplain: null })
															}}
														/>
													</Row>
												}
												<ActionDetails complain_uid={complain.uid} complain_status={complain.status} />
											</React.Fragment>
										)
									}}
								</Query>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
    
    
}

const COMPLAIN_BY_UID = gql`
    query barangayComplainByUid($complain_uid: String) {
		barangayComplainByUid(complain_uid: $complain_uid)
    }
`

const composed = compose(
	withRouter,
	observer
)

export default composed(Index)